var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "cleaContainer",
    staticClass: "clea-container"
  }, [_c('canvas', {
    ref: "cleaCanvas",
    staticClass: "clea-canvas"
  }), _c('CleaDialog', {
    ref: "cleaDialog",
    attrs: {
      "show": _vm.dialogManager.dialogOpen,
      "message": _vm.dialogManager.dialogText,
      "optionList": _vm.dialogManager.dialogOptionList,
      "autoDismiss": _vm.dialogManager.dialogAutoDismiss
    },
    on: {
      "change": function change(e) {
        return _vm.dialogManager.onSelection(e);
      },
      "show": function show(e) {
        return _vm.dialogManager.onShowChange(e);
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }